/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InitCreditApplicationV3_initCreditApplication_Contact = { readonly __typename: 'Contact' };

export type InitCreditApplicationV3_initCreditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly companyDivvyUuid: string | null };

export type InitCreditApplicationV3_initCreditApplication = InitCreditApplicationV3_initCreditApplication_Contact | InitCreditApplicationV3_initCreditApplication_CreditApplication;

export type InitCreditApplicationV3_Mutation = { readonly __typename: 'Mutation', readonly initCreditApplication: InitCreditApplicationV3_initCreditApplication };


export type InitCreditApplicationV3Variables = _Types.Exact<{
  accountId?: _Types.InputMaybe<_Types.Scalars['ID']['input']>;
  affiliateId?: _Types.InputMaybe<_Types.Scalars['Float']['input']>;
  applicant: _Types.PersonInput;
  businessInfo: _Types.BusinessInfoInput;
  recaptchaToken: _Types.Scalars['String']['input'];
  clientTimeZone?: _Types.InputMaybe<_Types.Scalars['String']['input']>;
  marketoBillLeadInput?: _Types.InputMaybe<_Types.MarketoBillLeadInput>;
  partnerCode?: _Types.InputMaybe<_Types.Scalars['String']['input']>;
  appVersion?: _Types.InputMaybe<_Types.Scalars['Int']['input']>;
}>;


export type InitCreditApplicationV3 = InitCreditApplicationV3_Mutation;


export const InitCreditApplicationV3Document = gql`
    mutation InitCreditApplicationV3($accountId: ID, $affiliateId: Float, $applicant: PersonInput!, $businessInfo: BusinessInfoInput!, $recaptchaToken: String!, $clientTimeZone: String, $marketoBillLeadInput: MarketoBillLeadInput, $partnerCode: String, $appVersion: Int) {
  initCreditApplication(
    accountId: $accountId
    affiliateId: $affiliateId
    applicant: $applicant
    businessInfo: $businessInfo
    recaptchaToken: $recaptchaToken
    clientTimeZone: $clientTimeZone
    marketoBillLeadInput: $marketoBillLeadInput
    partnerCode: $partnerCode
    appVersion: $appVersion
  ) {
    ... on CreditApplication {
      salesforceCreditId
      companyDivvyUuid
    }
  }
}
    `;
export type InitCreditApplicationV3MutationFn = Apollo.MutationFunction<InitCreditApplicationV3, InitCreditApplicationV3Variables>;

/**
 * __useInitCreditApplicationV3__
 *
 * To run a mutation, you first call `useInitCreditApplicationV3` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitCreditApplicationV3` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initCreditApplicationV3, { data, loading, error }] = useInitCreditApplicationV3({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      affiliateId: // value for 'affiliateId'
 *      applicant: // value for 'applicant'
 *      businessInfo: // value for 'businessInfo'
 *      recaptchaToken: // value for 'recaptchaToken'
 *      clientTimeZone: // value for 'clientTimeZone'
 *      marketoBillLeadInput: // value for 'marketoBillLeadInput'
 *      partnerCode: // value for 'partnerCode'
 *      appVersion: // value for 'appVersion'
 *   },
 * });
 */
export function useInitCreditApplicationV3(baseOptions?: Apollo.MutationHookOptions<InitCreditApplicationV3, InitCreditApplicationV3Variables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitCreditApplicationV3, InitCreditApplicationV3Variables>(InitCreditApplicationV3Document, options);
      }
export type InitCreditApplicationV3HookResult = ReturnType<typeof useInitCreditApplicationV3>;
export type InitCreditApplicationV3MutationResult = Apollo.MutationResult<InitCreditApplicationV3>;
export type InitCreditApplicationV3MutationOptions = Apollo.BaseMutationOptions<InitCreditApplicationV3, InitCreditApplicationV3Variables>;